import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  PaymentOrderSearchResult,
  PaymentReceiveOrderSearch,
  PaymentOrderSummaryResult,
} from "@/types/meesho/paymentOrder";
import {
  PaymentReferralResult,
  PaymentReferralSearch,
  PaymentReferralSummeryResult,
} from "@/types/meesho/PaymentReferral";
import {
  PaymentAdsCostResult,
  PaymentAdsCostSearch,
  PaymentAdsCostSummeryResult,
} from "@/types/meesho/PaymentAdsCost";

export const PaymentApi = createApi({
  reducerPath: "PaymentApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  keepUnusedDataFor: 0,
  tagTypes: ["meeshoPayment"],
  endpoints: (builder) => ({
    uploadPaymentOrder: builder.mutation({
      query: ({ formData }) => ({
        url: `/allpayments/payments/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["meeshoPayment"],
    }),
    searchPaymentOrder: builder.query<
      PaymentOrderSearchResult,
      PaymentReceiveOrderSearch
    
      >({
      query: (input) => ({
        url: `/orderpayment/search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["meeshoPayment"],
    }),
    exportPaymentOrders: builder.mutation<Blob, PaymentReceiveOrderSearch>({
      query: (input) => ({
        url: `/orderpayment/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    deletePaymentOrders: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/orderpayment/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshoPayment"],
    }),
    summaryPaymentOrders: builder.query<
      PaymentOrderSummaryResult,
      PaymentReceiveOrderSearch
    >({
      query: (input) => ({
        url: `/orderpayment/orderpayment_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshoPayment"],
    }),
    searchPaymentReferral: builder.query<
      PaymentReferralResult,
      PaymentReferralSearch
    >({
      query: (input) => ({
        url: `/referralpayments/referral_search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["meeshoPayment"],
    }),
    exportPaymentReferral: builder.mutation<Blob, PaymentReferralSearch>({
      query: (input) => ({
        url: `/referralpayments/referral_search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    deletePaymentReferral: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/referralpayments/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshoPayment"],
    }),
    summaryPaymentReferral: builder.query<
      PaymentReferralSummeryResult,
      PaymentReferralSearch
    >({
      query: (input) => ({
        url: `/referralpayments/referral_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshoPayment"],
    }),
    searchPaymentAdsCost: builder.query<
      PaymentAdsCostResult,
      PaymentAdsCostSearch
    >({
      query: (input) => ({
        url: `/adscost/adscostsearch`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["meeshoPayment"],
    }),
    exportPaymentAdsCost: builder.mutation<Blob, PaymentAdsCostSearch>({
      query: (input) => ({
        url: `/adscost/adscostsearch`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    deletePaymentAdsCost: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/adscost/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshoPayment"],
    }),
    summeryPaymentAdsCost: builder.query<
      PaymentAdsCostSummeryResult,
      PaymentAdsCostSearch
    >({
      query: (input) => ({
        url: `/adscost/adscostsummery`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshoPayment"],
    }),
  }),
});

export const {
  useUploadPaymentOrderMutation,
  useSearchPaymentOrderQuery,
  useLazySearchPaymentOrderQuery,
  useExportPaymentOrdersMutation,
  useSummaryPaymentOrdersQuery,
  useSearchPaymentReferralQuery,
  useLazySearchPaymentReferralQuery,
  useExportPaymentReferralMutation,
  useSummaryPaymentReferralQuery,
  useSearchPaymentAdsCostQuery,
  useLazySearchPaymentAdsCostQuery,
  useExportPaymentAdsCostMutation,
  useSummeryPaymentAdsCostQuery,
  useDeletePaymentAdsCostMutation,
  useDeletePaymentOrdersMutation,
  useDeletePaymentReferralMutation,
} = PaymentApi;
